/**
 * Thin navigation seam for the admin shell.
 *
 * Follows the per-widget sign-out navigate seam pattern (the PMS shell
 * has the sibling `widgets/pms-shell-v4/navigate.ts`). The sign-out flow
 * needs to leave the React tree entirely — the cleanest way in this app
 * is a hard `window.location.assign(...)`, the same pattern `LoginPage`
 * uses for the post-login transition. Wrapping the call in a
 * standalone module gives tests a single mock surface
 * (`vi.mock('../navigate.js')`), because `Location.assign` is
 * non-configurable in JSDOM 25 and direct `vi.spyOn` fails.
 *
 * Keep this file deliberately tiny: one exported function per
 * destination. Routing logic here would re-introduce the test
 * coupling we're avoiding.
 */

/**
 * Send the user to /login. Used by the admin account-menu sign-out
 * flow after the backend logout call + `queryClient.clear()` — the
 * hard navigation guarantees no stale React state survives.
 */
export function navigateToLogin(): void {
  if (typeof window === 'undefined') return;
  window.location.assign('/login');
}
